/*
 * Authors: mariushirjanu
 * Created: 21/12/2022
 */

import * as _ from 'underscore';
import { util } from '../../../../shared/util';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { IExtendedWindow, IObject } from '../../../../../type_definitions/datatypes';
import { BuyingGuideModel } from '../guide/buying-guide.model';
import { ICatalogProductImageList, OrderCatalogService } from '../order-catalog.service';
import { GaEventService, IGAEvent } from '../../../../shared/services/ga-event.service';
import { Subscription } from 'rxjs';
import { EVENT_ORDER_CART_CURRENCY_CHANGED, EVENT_ORDER_CART_STATUS_UPDATED } from '../../../../shared/app-events';
import { BreadcrumbService, IBreadcrumb } from '../../../../shared/breadcrumbs/breadcrumb.service';
import { GaStateService } from '../../../../shared/services/ga-state.service';
import { ScrollService } from '../../../../shared/scroll/scroll.service';
import { CatalogStateService } from '../catalog-state.service';
import { ICatalogProduct, ICatalogProductBundle, OrderCatalogDataService } from '../order-catalog-data.service';
import { PunchoutCatalogService } from '../../entry/catalog/punchout-catalog.service';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { UrlService } from '../../../../shared/browser/url.service';
import { trackByFunction } from '../../../../shared/formly/ga-formly.util';

const ICECAT_LIVE_USERNAME:string = 'acsl_icecat';

@Component({
  selector: 'order-catalog-detail',
  template: `
    <div *ngIf="error && !loading" class="alert alert-danger"><strong>{{error}}</strong></div>
    <div *ngIf="!error && !loading && product">
      <div class="catalog-detail">
        <div class="top-container">
          <div class="row">
            <div class="col-sm-7 title">
              <div class="item-title">{{product.title}}</div>
              <div class="badge partnumber">{{product.part}}</div>
            </div>
            <div class="col-sm-5">
              <div class="price-block">
                <span *ngIf="product?.optional !== false">
                  <div *ngIf="product.price?.amount || product.unitLeasePrice?.amount" class="price">
                    <span class="margin-bottom-sm" *ngIf="product.price.amount && !hidePrices">{{formatAmount(product.price.amount)}}</span>
                    <span *ngIf="showLease && product.unitLeasePrice?.amount" translate [translateParams]="{ amount: formatAmount(product.unitLeasePrice?.amount), period: product.leasePeriod }">
                      {{hidePrices ? 'CATALOG.DETAIL.LEASE_INFO_SHORT' : 'CATALOG.DETAIL.LEASE_INFO'}}
                    </span>
                  </div>
                  <add-to-cart class="float-end" [product]="product" [catalogView]="true"></add-to-cart>
                </span>
                <span *ngIf="product?.optional === false">
                  <!--suppress HtmlUnknownTag -->
                  <div class="bundle-expl" translate>CATALOG.DETAIL.PART_OF_BUNDLE</div>
                      <!--suppress HtmlUnknownTag -->
                  <div class="bundle-link">
                    <a [uiSref]="parentBundle.sref" [uiParams]="parentBundle.srefParams" [uiOptions]="{inherit: false}">{{parentBundle.name}}</a>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="content">
          <div class="row description-block">

            <div *ngIf="images" class="images col-sm-6 col-sm-pull-6">
              <slick [images]="images.large" [thumbs]="images.small"></slick>
            </div>

            <div [ngClass]="{'col-sm-6 col-sm-push-6': images, 'col-sm-12': !images}">
              <div class="description pre-line" [innerHTML]="product.description"></div>
              <favourite-toggle [productId]="product.id" [isFavourite]="product.favourite">
                <span translate>CATALOG.DETAIL.FAVOURITE_TOGGLE</span>
              </favourite-toggle>
              <div class="stock" *ngIf="showStock && (product.stock || product.stock === 0)">
                <span translate>CATALOG.HEADERS.STOCK_COUNT</span>: {{product.stock}}
              </div>
              <div class="warning-field warn" *ngIf="product.warning || product.EOL?.warning">
                <div *ngIf="product.warning">
                  <i class="fa fa-warning"></i>
                  {{product.warning}}
                </div>
                <div *ngIf="product.EOL?.warning">
                  <i class="fa fa-warning"></i>
                  <span translate [translateParams]="{date: product.EOL?.date}">
                    CATALOG.DETAIL.EOL_WARNING
                  </span>
                </div>
              </div>
              <div class="lead-time" *ngIf="product.leadTime?.days" [ngClass]="{'warning-field': product.leadTime.warning}">
                <span *ngIf="product.leadTime?.warning">
                  <i class="fa fa-warning"></i>
                </span>
                <span translate [translateParams]="{days: product.leadTime.text}">CATALOG.DETAIL.LEAD_TIME</span>
              </div>


              <div class="navigation">
                <ul>
                  <li *ngIf="included?.length">
                    <a href="" (click)="scrollTo($event, 'included')" translate>CATALOG.DETAIL.BUNDLE_ITEMS</a>
                  </li>
                  <li *ngIf="optional?.length">
                    <a href="" (click)="scrollTo($event, 'optional')" translate>CATALOG.DETAIL.OPTIONAL_ITEMS</a>
                  </li>
                  <li>
                    <a href="" (click)="scrollTo($event, 'specs')" translate>CATALOG.DETAIL.TECHSPECS.TITLE</a>
                  </li>
                  <li *ngIf="product.compatibleProducts">
                    <a [uiSref]="compatibleSREF" [uiParams]="compatibleSREFParams">
                      <span translate>CATALOG.DETAIL.COMPATIBLE_PRODUCTS</span><i class="fa fa-angle-right"></i>
                    </a>
                  </li>
                </ul>
              </div>

            </div>

          </div>

          <!-- Non-optional bundle items -->
          <div *ngIf="included?.length" class="bundle" scrollTarget="included">
            <h3 translate>CATALOG.DETAIL.BUNDLE_ITEMS</h3>
            <table class="table-striped table-bordered table">
              <tbody>
                <tr>
                  <th class="desc" translate>CATALOG.HEADERS.DESCRIPTION</th>
                  <th class="part" translate>CATALOG.HEADERS.PARTNR</th>
                  <th class="qty" translate>CATALOG.HEADERS.QTY</th>
                  <th class="cat" translate>CATALOG.HEADERS.CATEGORY</th>
                </tr>
                <tr *ngFor="let item of included; trackBy: trackByFunction">
                  <td class="desc">
                    <a class="pre-line" [uiSref]="orderDetailsSref" [uiParams]="bundleSREFParams(item.id)" [innerHTML]="item.description"></a></td>
                  <td class="part"><span class="badge partnumber">{{item.part}}</span></td>
                  <td class="qty">{{item.quantity * numProducts}}</td>
                  <td class="cat">{{item.category}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Optional bundle items -->
          <div *ngIf="optional?.length" class="bundle" scrollTarget="optional">
            <h3 translate>CATALOG.DETAIL.OPTIONAL_ITEMS</h3>
            <table class="table-striped table-bordered table">
              <tbody>
                <tr>
                  <th class="desc" translate>CATALOG.HEADERS.DESCRIPTION</th>
                  <th class="part" translate>CATALOG.HEADERS.PARTNR</th>
                  <th class="cat" translate>CATALOG.HEADERS.CATEGORY</th>
                  <th class="prc" translate>CATALOG.HEADERS.PRICE</th>
                  <th class="inc"></th>
                </tr>
                <tr *ngFor="let item of optional; trackBy: trackByFunction">
                  <td class="desc"><a class="pre-line" [uiSref]="orderDetailsSref" [uiParams]="bundleSREFParams(item.id)" [innerHTML]="item.description"></a></td>
                  <td class="part"><span class="badge partnumber">{{item.part}}</span></td>
                  <td class="cat">{{item.category}}</td>
                  <td class="prc">{{item._price()}}</td>
                  <td class="inc">
                    <add-to-cart [product]="item" [catalogView]="true" [mini]="true"></add-to-cart>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div class="specs" scrollTarget="specs">
            <h3 translate>CATALOG.DETAIL.TECHSPECS.TITLE</h3>
            <table class="table">
              <tbody>
                <tr class="header">
                  <td colspan="2"><h4 translate>CATALOG.DETAIL.TECHSPECS.PRODUCT</h4></td>
                </tr>
                <tr class="even">
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.DESCRIPTION</td>
                  <td class="spec-description pre-line" [innerHTML]="product.description"></td>
                </tr>
                <tr>
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.CATEGORY</td>
                  <td>{{product.category}}</td>
                </tr>
                <tr class="even">
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.VENDOR</td>
                  <td>{{product.vendor}}</td>
                </tr>
                <tr>
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.SHORT_DESC</td>
                  <td>{{product.shortDescription}}</td>
                </tr>
                <tr class="even">
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.LOCAL_PARTNR</td>
                  <td>
                    <div class="badge partnumber">{{product.part}}</div>
                  </td>
                </tr>
                <tr>
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.GLOBAL_PARTNR</td>
                  <td>
                    <div class="badge partnumber">{{product.globalPart}}</div>
                  </td>
                </tr>
                <tr class="even website">
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.WEBSITE</td>
                  <td><a href="{{product.url}}" target="_blank">{{product.url}}</a></td>
                </tr>
                <tr>
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.DOCUMENTATION</td>
                  <td><a href="{{product.documentUrl}}" target="_blank">{{product.documentDescription}}</a></td>
                </tr>
                <tr class="even">
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.EOL_DATE</td>
                  <td [ngClass]="{'warning-field': product.EOL?.warning}">
                    <i *ngIf="product.EOL?.warning"
                      title="{{'CATALOG.DETAIL.EOL_WARNING' | translate: {date: product.EOL?.date} }}"
                      class="fa fa-warning"></i>
                    {{product.EOL?.date}}
                  </td>
                </tr>
                <tr *ngIf="product.warning">
                  <td class="name" translate>CATALOG.DETAIL.TECHSPECS.WARNING</td>
                  <td class="warning-field"><i class="fa fa-warning"></i>{{product.warning}}</td>
                </tr>

                <ng-container *ngFor="let prop of product.properties; trackBy: trackByFunction">
                  <tr class="header">
                    <td colspan="2">
                      <h4>{{prop.name}}</h4>
                    </td>
                  </tr>
                  <tr *ngFor="let value of prop.values; trackBy: trackByFunction; let index = index" [ngClass]="{even: index%2 === 0}">
                    <td class="name">{{value.name}}</td>
                    <td [innerHTML]="value.value"></td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div class="ic-catalog" *ngIf="product.showIcecatDetails">
            <div id="ic-data" #icdata></div>
          </div>

        </div>

      </div>

      <div *ngIf="loading" class="catalog-detail-overlay">
        <div class="bg"></div>
        <div class="text">
          <activity-indicator></activity-indicator><br />
          <span translate>GA.LOADING_SIMPLE</span>…
        </div>
      </div>

    </div>
  `
})
export class OrderCatalogDetailComponent implements OnInit, OnDestroy {
  @ViewChild('icdata') icecatData:any;

  public error:string;
  public included:ICatalogProductBundle[];
  public optional:ICatalogProductBundle[];
  public product:ICatalogProduct;
  public loading:boolean;
  public formatAmount = this.orderCatalogService.formatAmount;
  public parentBundle:IObject;
  public images:ICatalogProductImageList;
  public showStock:boolean;
  public compatibleSREF:string;
  public compatibleSREFParams:IObject;
  public trackByFunction:Function = trackByFunction;
  public numProducts:number;
  public orderDetailsSref:string;
  public showLease:boolean;
  public hidePrices:boolean;

  private productId:number;
  private compatProductId:number;
  private guide:string;
  private partNumber:string;
  private eventHandler:Subscription;

  constructor(
    @Inject(Window) private window:IExtendedWindow,
    private breadcrumbService:BreadcrumbService,
    private gaStateService:GaStateService,
    private scrollService:ScrollService,
    private eventService:GaEventService,
    private orderCatalogService:OrderCatalogService,
    private catalogStateService:CatalogStateService,
    private orderCatalogDataService:OrderCatalogDataService,
    private buyingGuideModel:BuyingGuideModel,
    private punchoutCatalogService:PunchoutCatalogService,
    private authService:AuthService,
    private urlService:UrlService,
    private stateService:StateService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.showStock = this.orderCatalogService.showStock;
    this.showLease = this.orderCatalogService.isLeasingWebshop;
    this.hidePrices = this.orderCatalogService.hidePrices;

    this.numProducts = 1;
    this.parentBundle = {
      id: undefined,
      name: undefined,
      srefParams: undefined
    };
    this.orderDetailsSref = this.catalogStateService.detailState;

    this.activate();
    this.listen();
  }

  private activate():void {
    this.getStateParams();

    this.buyingGuideModel.searchCode(this.guide);
    this.buyingGuideModel.showingAll(false);

    this.orderCatalogService.isStarted()
      .then(() => {
        this.initBreadcrumbs();
        this.loadProduct();
      });
  }

  private listen():void {
    this.eventHandler = this.eventService.events.subscribe((event:IGAEvent) => {
      if(event.name === EVENT_ORDER_CART_CURRENCY_CHANGED){
        this.loadProduct();
      }

      else if (event.name === EVENT_ORDER_CART_STATUS_UPDATED) {
        this.numProducts = Number(event.data[this.productId]) || 1;
      }
    });
  }

  private getStateParams():void {
    this.productId = this.stateService.params.product;
    this.compatProductId = this.stateService.params.compat;
    this.guide = this.stateService.params.guide;
    this.partNumber = this.stateService.params.part;
    this.parentBundle.id = this.stateService.params.bundle;

    if (util.isNullOrUndefinedOrEmpty(this.productId) && util.isNullOrUndefinedOrEmpty(this.partNumber)) {
      this.error = 'Missing productId or partNumber';
    }
  }

  private initBreadcrumbs():void {
    const breadcrumbs:IBreadcrumb[] = this.breadcrumbService.breadcrumbs;

    if (!breadcrumbs[ 0 ] || breadcrumbs[ 0 ].state !== this.catalogStateService.overviewState) { //if there is one, keep it
      breadcrumbs[ 0 ] = this.breadcrumbService.create('Products', this.catalogStateService.overviewState, this.catalogStateService.createStateParams({ part: undefined }));
    }

    if (this.compatProductId) {
      if (!breadcrumbs[ 1 ] || breadcrumbs[ 1 ].state !== this.catalogStateService.detailState) {
        breadcrumbs[ 1 ] = this.breadcrumbService.create(`Product ${this.compatProductId}`,
          this.catalogStateService.detailState,
          this.catalogStateService.createStateParams({ product: this.compatProductId }));
      }

      if (!breadcrumbs[ 2 ] || breadcrumbs[ 2 ].state !== this.catalogStateService.overviewState) {
        breadcrumbs[ 2 ] = this.breadcrumbService.create('Compatible products',
          this.catalogStateService.overviewState,
          this.catalogStateService.createStateParams({ compat: this.compatProductId }));
      }

      if (!breadcrumbs[ 3 ] || breadcrumbs[ 3 ].state !== this.catalogStateService.detailState) {
        breadcrumbs[ 3 ] = this.breadcrumbService.create(`Product ${this.productId}`,
          this.catalogStateService.detailState,
          this.catalogStateService.createStateParams({
            compat: this.compatProductId,
            product: this.productId
          }));
      }
      breadcrumbs.splice(4, breadcrumbs.length - 4);
    } else if (this.parentBundle.id) {
      if (!breadcrumbs[ 1 ] || breadcrumbs[ 1 ].state !== this.catalogStateService.detailState) {
        breadcrumbs[ 1 ] = this.breadcrumbService.create(`Bundle ${this.parentBundle.id}`,
          this.catalogStateService.detailState,
          this.catalogStateService.createStateParams({ product: this.parentBundle.id }));
      }

      if (!breadcrumbs[ 2 ] || breadcrumbs[ 2 ] !== <any>this.catalogStateService.detailState) {
        breadcrumbs[ 2 ] = this.breadcrumbService.create(`Product ${this.productId}`,
          this.catalogStateService.detailState,
          this.catalogStateService.createStateParams({
            bundle: this.parentBundle.id,
            product: this.productId
          }));
      }
      breadcrumbs.splice(3, breadcrumbs.length - 3);
    } else {
      breadcrumbs[ 1 ] = this.breadcrumbService.create(`Product ${this.productId}`,
        this.catalogStateService.detailState,
        this.catalogStateService.createStateParams({ product: this.productId }));
      breadcrumbs.splice(2, breadcrumbs.length - 2);
    }

    this.compatibleSREF = this.catalogStateService.overviewState;
    this.compatibleSREFParams = {
      compat: this.productId,
      guide: this.guide
    };
    this.parentBundle.name = `Bundle ${this.parentBundle.id}`;
    this.parentBundle.sref = this.catalogStateService.detailState;
    this.parentBundle.srefParams =
      this.catalogStateService.createStateParams({
        product: this.parentBundle.id,
        guide: this.guide
      });


    this.breadcrumbService.breadcrumbs = breadcrumbs;
  }

  public bundleSREFParams(itemId:number):IObject {
    return util.deepClone({
      bundle: this.productId,
      product: itemId,
      guide: this.guide
    });
  }

  private loadProduct():void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    //always load the main product in full
    this.orderCatalogDataService.product(this.productId, this.partNumber, this.parentBundle.id, undefined)
      .then((product:ICatalogProduct) => {
        this.product = {
          ...product,
          unitPrice: product.price?.amount,
          documentUrl: this.urlService.getAttachmentUrl(product.documentId)
        };

        if (product?.images) {
          this.images = this.orderCatalogService.imageURLs(product.images);
        }

        this.included = [];
        this.optional = [];

        if (product.bundle) {
          _.each(product.bundle, (bundleItem:ICatalogProductBundle) => {
            if (bundleItem.optional) {
              this.optional.push(bundleItem);
              if (bundleItem.price) {
                bundleItem._price = () => this.formatAmount(bundleItem?.price?.amount, 1, bundleItem?.price?.currency);
              }
            } else {
              this.included.push(bundleItem);
            }
          });
        }

        this.breadcrumbService.setTitle(this.breadcrumbService.breadcrumbs.length - 1, product.shortDescription);

        // load icecat data
        if (product.showIcecatDetails) {
          this.loadIcecatData();
        }
      })
      .catch(() => {
        //jump back to overview screen
        const bcs:IBreadcrumb[] = this.breadcrumbService.breadcrumbs;
        const back:IBreadcrumb = bcs[ bcs.length - 2 ];
        this.stateService.go(back.state, back.stateParams, {
          inherit: false,
          location: 'replace'
        });
      })
      .finally(() => {
        this.loading = false;
        // clear part number query param after use
        this.clearPartNumberParam();
      });

    //only load the other product summary for updating the breadcrumb
    const otherProductId:number = this.compatProductId? this.compatProductId : this.parentBundle.id;
    if (otherProductId) {
      this.orderCatalogDataService.product(otherProductId, undefined, undefined, true)
        .then((product:ICatalogProduct) => {
          if (this.parentBundle.id) {
            this.parentBundle.name = `Bundle ${product.shortDescription}`;
            this.breadcrumbService.setTitle(1, this.parentBundle.name);
          } else {
            this.breadcrumbService.setTitle(1, product.shortDescription);
          }
        })
        .catch(util.noop);
    }
  }

  private clearPartNumberParam():void {
    // clear part number query param after use
    this.punchoutCatalogService.punchoutPartNumber = undefined;
    this.gaStateService.updateStateParameter('part', undefined);

    this.partNumber = undefined;
  }

  private loadIcecatData():void {
    const userLanguage:string = this.authService.getCurrentUser()?.language?.isoCode;
    if (this.window.IcecatLive && this.product.globalPart) {
      try {
        this.window.IcecatLive.getDatasheet(
          '#ic-data', // target element
          {
            UserName: ICECAT_LIVE_USERNAME,
            Brand: this.product.vendor,
            ProductCode: this.product.globalPart
          },
          userLanguage, // language
          200 // timeout
        ).then(() => {
          // workaround for redirecting to error page when url contains /ga2#icecatContent
          $(this.icecatData.nativeElement).find('a').each((index:number, elm:HTMLElement) => {
            const linkElement:JQuery<HTMLElement> = $(elm);
            if(linkElement.attr('href')?.startsWith('#')) {
              linkElement.attr('link-target', linkElement.attr('href')); // save link target
              linkElement.attr('href', 'javascript:void(0)'); // prevent from redirecting

              linkElement.on('click', () => {
                this.scrollService.scrollToElement(linkElement.attr('link-target'));
              });
            }
          });
        })
          .catch(util.noop); // silent icecat library error: Uncaught (in promise): Mandatory data request failed
      } catch (e) { /**/
      }
    }
  }
  
  public scrollTo:Function = (event:Event, scrollTarget:string):void => {
    event.preventDefault();
    return this.scrollService.scrollTo(scrollTarget);
  };

  public ngOnDestroy():void {
    this.eventHandler?.unsubscribe();
  }
}